














import axios from 'axios'
import Vue from 'vue'

import { IdObject } from '@/components/artifacts/module/types.ts'
import WithTag from '@/components/WithTag'

export default Vue.extend({
  components: { WithTag },
  computed: {
    hasArtifacts(): boolean {
      return this.artifacts.length > 0
    },
    artifacts(): IdObject[] {
      let artifacts: IdObject[] = this.$store.getters[`${this.from}/storedObjectsArray`]
      if (this.where) {
        artifacts = artifacts.filter(() => this.where)
      }
      if (this.sort) {
        artifacts = artifacts.sort((a: IdObject, b: IdObject) => this.sort?.(a, b))
      }
      if (this.revert) {
        artifacts = artifacts.reverse()
      }
      return artifacts
    },
  },
  created() {
    this.$store.dispatch({ type: `${this.from}/pullObjects` })
  },
  methods: {
    async store(artifact: object, updateInstance: boolean = false) {
      return this.$store.dispatch({
        object: artifact,
        type: `${this.from}/pushObject`,
        updateInstance,
      })
    },
  },
  props: {
    from: {
      required: true,
      type: String,
    },
    pull: {
      default: false,
      type: Boolean,
    },
    tag: {
      default: 'div',
      type: String,
    },
    where: {
      type: Function,
    },
    sort: {
      type: Function,
    },
    revert: {
      type: Boolean,
      default: false,
    },
  },
})
